var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatWhiteTransparent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "ivory"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#f9f9ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebebeb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chat",
    transform: "translate(-6 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1857",
    "data-name": "Path 1857",
    d: "M20.889,40.444H40.444l7.333,7.333V20.889A4.889,4.889,0,0,0,42.889,16h-22A4.889,4.889,0,0,0,16,20.889V35.556a4.889,4.889,0,0,0,4.889,4.889",
    transform: "translate(2.222 2.222)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1858",
    "data-name": "Path 1858",
    d: "M34.111,30.444H13.333L6,37.778V10.889A4.889,4.889,0,0,1,10.889,6H34.111A4.889,4.889,0,0,1,39,10.889V25.556a4.889,4.889,0,0,1-4.889,4.889",
    transform: "translate(0 0)",
    opacity: 0.4,
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatWhiteTransparent);
export default __webpack_public_path__ + "static/media/chat_white-transparent.50a8f895dca86185d73f42172ff0d3a9.svg";
export { ForwardRef as ReactComponent };